import { render } from "./PostCard.vue?vue&type=template&id=7a28b078&scoped=true&ts=true"
import script from "./PostCard.vue?vue&type=script&lang=ts"
export * from "./PostCard.vue?vue&type=script&lang=ts"

import "./PostCard.vue?vue&type=style&index=0&id=7a28b078&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a28b078"]])

export default __exports__